/**
 * @desc workData (data pertaining to the work will go here serves as the source data for experience page)
 * 
 */

export default [
    {
        id: 1,
        name: "Udemy",
        designation: "Mentor, Code Reviewer and Teaching Assistant",
        dated: "Dec 2018 - Present",
        logo: null,
        companyLink: "somethingloremoipsum",
        description: `Lorem Ipsum is simply dummy text of the printing and typesetting 
        industry. Lorem Ipsum has been the industry's standard dummy text ever since the 
        1500s, when an unknown printer took a galley of type and scrambled it to make 
        a type specimen book. It has survived not only five centuries, but also the leap
        into electronic typesetting, remaining essentially unchanged. It was popularised 
        in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, 
        and more recently with desktop publishing software like Aldus PageMaker including 
        versions of Lorem Ipsum.`,
    },
    {
        id: 2,
        name: "Mackerax",
        designation: "Angular.js Developer",
        dated: "Sep 2017 - Jan 2018",
        logo: null,
        companyLink: "somethingloremoipsum",
        description: `Lorem Ipsum is simply dummy text of the printing and typesetting 
        industry. Lorem Ipsum has been the industry's standard dummy text ever since the 
        1500s, when an unknown printer took a galley of type and scrambled it to make 
        a type specimen book. It has survived not only five centuries, but also the leap
        into electronic typesetting, remaining essentially unchanged. It was popularised 
        in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, 
        and more recently with desktop publishing software like Aldus PageMaker including 
        versions of Lorem Ipsum.`,
    },
    {
        id: 3,
        name: "The Datum Guy",
        designation: "Full Stack Developer",
        dated: "Jun 2018 - July 2018",
        logo: null,
        companyLink: "somethingloremoipsum",
        description: `Lorem Ipsum is simply dummy text of the printing and typesetting 
        industry. Lorem Ipsum has been the industry's standard dummy text ever since the 
        1500s, when an unknown printer took a galley of type and scrambled it to make 
        a type specimen book. It has survived not only five centuries, but also the leap
        into electronic typesetting, remaining essentially unchanged. It was popularised 
        in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, 
        and more recently with desktop publishing software like Aldus PageMaker including 
        versions of Lorem Ipsum.`,
    },
    {
        id: 4,
        name: "Unique Touch Solutions",
        designation: "Vue.is Developer",
        dated: "Jun 2018 - July 2018",
        logo: null,
        companyLink: "somethingloremoipsum",
        description: `Lorem Ipsum is simply dummy text of the printing and typesetting 
        industry. Lorem Ipsum has been the industry's standard dummy text ever since the 
        1500s, when an unknown printer took a galley of type and scrambled it to make 
        a type specimen book. It has survived not only five centuries, but also the leap
        into electronic typesetting, remaining essentially unchanged. It was popularised 
        in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, 
        and more recently with desktop publishing software like Aldus PageMaker including 
        versions of Lorem Ipsum.`,
    }
]
